// VESZÉLYZÓNA — a visszafordíthatatlan műveletek (törlés, archiválás, átadás) dedikált, vizuálisan
// ELKÜLÖNÜLŐ helye egy detail-oldal legalján.
//
// MIÉRT NEM elég egy sima szekció piros gombbal: a többi szekció szándékosan visszafogott (keret és háttér
// NÉLKÜLI `FormSection`), mert az oldal egységes, nyugodt felület. Pont ezért olvad bele egy közéjük tett
// törlés-gomb is — miközben ez az EGYETLEN művelet az oldalon, ami nem vonható vissza. A bevett iparági minta
// (GitHub, Vercel, Stripe, Supabase) ezért a zónát KERETTEL + veszély-tónusú háttérrel emeli ki: a szín és a
// keret maga a figyelmeztetés, még mielőtt a felhasználó elolvasná a szöveget.
//
// A ZÓNA FELELŐSSÉGE, hogy a veszélyes akció NE legyen egy kattintás: a gomb csak megnyitja a megerősítő
// dialógust (a hívó dolga) — a tényleges végrehajtás mindig két lépés.
//
// A GOMB-VARIÁNS ITT VAN ELDÖNTVE, nem a hívóban: a `destructive` (tömör piros) használata garantáltan
// egységes minden veszélyzónában. Így nem fordulhat elő, hogy az egyik oldalon `outline` + piros ikon, a
// másikon tömör piros gomb áll ugyanarra a műveletre.
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/text';

export function DangerZone({
  /** Horgony a szekció-navigációhoz (lásd `FormSection` `id`). */
  id,
  /** A zóna címe (overline) — jellemzően „Veszélyzóna". */
  title,
  /** MI a művelet (a keretes doboz sor-címe), pl. „Ügyfél törlése". */
  actionTitle,
  /** MI TÖRTÉNIK, ha megteszed — a következmények, egyszerű mondatban. */
  description,
  /** A gomb felirata. */
  actionLabel,
  onAction,
  disabled = false,
}: {
  id?: string | undefined;
  title: string;
  actionTitle: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  disabled?: boolean;
}): JSX.Element {
  return (
    <section
      {...(id ? { id, tabIndex: -1 } : {})}
      className="scroll-mt-6 space-y-4 focus:outline-none"
    >
      {/* A cím tipográfiája a többi szekcióéval EGYEZŐ (overline), de veszély-tónusban — a rendszer egységes
          marad, a jelentés mégis azonnal olvasható. */}
      <Text variant="overline" as="h2" className="text-danger-600 dark:text-danger-400">
        {title}
      </Text>
      <div className="border-danger-200 bg-danger-soft/60 dark:border-danger-500/30 dark:bg-danger-soft/40 flex flex-col gap-4 rounded-xl border p-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <ExclamationTriangleIcon
            className="text-danger-600 dark:text-danger-400 mt-0.5 size-5 shrink-0"
            aria-hidden="true"
          />
          <div className="min-w-0 space-y-1">
            <p className="text-foreground text-sm font-medium">{actionTitle}</p>
            <p className="text-muted-foreground text-sm">{description}</p>
          </div>
        </div>
        {/* `shrink-0` + `sm:self-center`: a gomb szélessége soha nem függ a szöveg hosszától. Mobilon teljes
            szélességű sor alatta, hogy a hüvelykujj-zónába essen. */}
        <Button
          type="button"
          variant="destructive"
          onClick={onAction}
          disabled={disabled}
          className="shrink-0 max-sm:w-full"
        >
          {actionLabel}
        </Button>
      </div>
    </section>
  );
}
